import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';
interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  icon?: React.ReactNode;
  error?: string;
}
export function Input({
  label,
  icon,
  error,
  className = '',
  ...props
}: InputProps) {
  const {
    isLight
  } = useTheme();
  return <div className={`w-full ${className}`} data-id="element-336">
      {label && <label className={`block text-sm font-medium mb-1.5 ${isLight ? 'text-slate-700' : 'text-zinc-400'}`} data-id="element-337">
          {label}
        </label>}
      <div className="relative" data-id="element-338">
        {icon && <div className={`absolute left-3 top-1/2 -translate-y-1/2 ${isLight ? 'text-slate-400' : 'text-zinc-500'}`} data-id="element-339">
            {icon}
          </div>}
        <input className={`
            w-full rounded-xl transition-all outline-none
            ${icon ? 'pl-10' : 'pl-4'} pr-4 py-3
            ${isLight ? 'bg-white border border-slate-200 text-slate-900 placeholder:text-slate-400 focus:border-vexu focus:ring-4 focus:ring-vexu/10 shadow-sm' : 'bg-dark-card/60 backdrop-blur-xl border border-white/10 text-white placeholder:text-zinc-500 focus:border-vexu focus:ring-2 focus:ring-vexu/20'}
            ${error ? isLight ? 'border-red-500 focus:border-red-500 focus:ring-red-500/10' : 'border-red-500/50 focus:border-red-500 focus:ring-red-500/20' : ''}
          `} {...props} data-id="element-340" />
      </div>
      {error && <p className="mt-1.5 text-sm text-red-500" data-id="element-341">{error}</p>}
    </div>;
}